<template>
  <form enctype="multipart/form-data">
    <input
      type="file"
      ref="fileInput"
      class="d-none"
      :name="type"
      :disabled="saving"
      :accept="accept"
      :multiple="accMultiple"
      @change="onChange"
    />
    <b-btn v-if="!fileList.length" type="button" class="btn btn-start" v-text="_trans('Choose file')" @click="triggerClick($event)"></b-btn>
    <div v-else class="btn-group" :disabled="saving">
      <b-btn type="button" class="btn btn-start" :disabled="saving" @click="upload">
        <span v-if="fileList.length > 1" v-text="_trans('Upload files')"></span>
        <span v-else v-text="_trans('Upload') +' '+ fileList[0].name"></span>
      </b-btn>
      <b-btn type="reset" class="btn btn-secondary" :disabled="saving" @click="resetFileList($event)">
        <i class="di di-trash"></i>
      </b-btn>
    </div>
  </form>
</template>
<script>
    import {bus} from "@store/dau";
    import { HandlerAPI, NextApiClient } from '@3cad/nextcore';

    export default {
        props: {
            name: { type: String, default: ''},
            newname: {type: String, default: ''},
            type: { type: String, default: 'GEN' },
            catalog: {type: String, default: ''},
            dim: String,
            height: {type: String, default: '100px'},
            image: String,
            accMultiple: { type: Boolean, default: false },
            accImages: { type: Boolean, default: false },
            accDocs: { type: Boolean, default: true },
            prjId: { type: Number, default: 0 }
        },
        data () {
            return {
                fileList: [],
                saving: false
            }
        },
        computed: {
            accept () {
                let accept = [];

                if(this.accImages)
                    accept.push('image/*');

                if(this.accDocs)
                    accept.push('.doc', '.docx', '.pdf', '.txt');

                // return this.images ? 'image/*' : '*/*'
                return accept.join(',');
            },
            prj() {
                return this.$store.state.project;
            }
        },
        mounted() {
            console.log(this);
        },
        updated() {
            console.log(this);
        },
        methods: {
            triggerClick(e) {
                this.$refs.fileInput.click();
            },
            resetFileList(e) {
                this.fileList = [];
            },
            /*filesChange (fileList, linklist) {
                this.saving = true
                Dau.sendFiles(fileList, this.type, this.name, this.newname, this.dim, linklist,
                    res => {
                        this.saving = false;
                        this.$emit('loaded', res);
                    },
                    err => {
                        this.saving = false;
                        this.$emit('error', err);
                    })
            },*/
            onChange(e) {
                console.warn(e.target.files);
                if(e.target && e.target.files)
                    this.fileList = e.target.files;
                else {
                    this.fileList = [];
                }
            },
            updateFiles(fileList, prjId) {
                HandlerAPI.uploadFiles(this.fileList, this.prjId || this.prj.id, evt => {
                        bus.$emit('startLoading', null, evt.loaded / evt.total)
                    },
                    res => {
                        bus.$emit('stopLoading');
                        this.saving = false;
                        this.resetFileList(e);
                        this.$emit('loaded', res);
                    },
                    err => {
                        bus.$emit('stopLoading');
                        this.saving = false;
                        this.resetFileList(e);
                        this.$emit('error', err);
                    })
            },
            upload (e) {
                this.saving = true
                let params = {
                    uploadmode: 0,
                    projectId: this.prjId || this.prj.id
                }

                Array.from(Array(this.fileList.length).keys())
                    .map(x => {
                        params[this.fileList[x].name] = this.fileList[x];
                    });


                NextApiClient.comHandler('soapupload', params, {
                    responseType: 'text'
                },(res) => {
                    bus.$emit('stopLoading');
                    this.saving = false
                    this.resetFileList(e);
                    this.$emit('loaded', res);
                }, (err) => {
                    bus.$emit('stopLoading');
                    this.saving = false;
                    this.resetFileList(e);
                    this.$emit('error', err);
                }, (evt) => {
                    bus.$emit('startLoading', null, evt.loaded / evt.total)
                })

                /*HandlerAPI.uploadFiles(this.fileList, this.prjId || this.prj.id, evt => {
                        bus.$emit('startLoading', null, evt.loaded / evt.total)
                    }, res => {
                        bus.$emit('stopLoading');
                        this.saving = false
                        this.resetFileList(e);
                        this.$emit('loaded', res);
                    },
                    err => {
                        bus.$emit('stopLoading');
                        this.saving = false;
                        this.resetFileList(e);
                        this.$emit('error', err);
                    })*/
            }
        }
    }
</script>
<style scoped lang="scss"></style>



// WEBPACK FOOTER //
// src/_eng/globals/_upload.vue